import React from 'react'
import Cart from 'services/cart/Cart'
import CartWriter from 'services/cart/CartWriter'
import { Collection } from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import CartContent from 'services/cart/CartContent'
import { WhenRouteIs, WhenRouteIsNot } from '@morningtrain/react-navigation'
import ConfirmCartBanner from 'services/cart/ConfirmCartBanner'
import DefaultCartBanner from 'services/cart/DefaultCartBanner'

export default function CartWrapper (props) {
  return (
    <Cart>
      <CartWriter />
      <Collection resourceName='domains' operationContext='cart_content'>
        <Filters.StaticFilter name='$per_page' value={0} />
        <Filters.CartFilter />
        <CartContent>
          {props.children}
          <WhenRouteIsNot route='app.shop.cart.index'>
            <DefaultCartBanner />
          </WhenRouteIsNot>
          <WhenRouteIs route='app.shop.cart.index'>
            <ConfirmCartBanner />
          </WhenRouteIs>
        </CartContent>
      </Collection>
    </Cart>
  )
}
